export const STORE_PERMISSIONS_NAME = 'permissions';

export const STATE_ALL_PERMISSONS = 'allPermissions';
export const STATE_PERMISSIONS_BY_CATEGORY = 'permissionsByCategory';

export const GETTER_ALL_PERMISSIONS = 'allPermissions';
export const GETTER_PERMISSIONS_BY_CATEGORY = 'permissionsByCategory';

export const MUTATION_SET_ALL_PERMISSIONS = 'setAllPermissions';
export const MUTATION_SET_PERMISSIONS_BY_CATEGORY = 'setPermissionsByCategory';

export const ACTION_GET_ALL_PERMISSIONS = 'getPermissions';

